<template>
  <div class="Meeting-container" style="padding: 10px;margin-bottom:50px; ">
    <!-- 任务管理栏 -->
    <div class="task-bar">
      <el-button type="primary" size="small" icon="el-icon-plus" @click="createNewTask">新建任务</el-button>
      <div class="task-list">
        <div
            v-for="task in tasks"
            :key="task.id"
            class="task-item"
            :class="{ active: currentTaskId === task.id }"
            @click="switchTask(task.id)"
        >
          <el-input
              v-if="editingTaskId === task.id"
              v-model="task.name"
              size="mini"
              :ref="'taskNameInput_' + task.id"
              @blur="finishEditTaskName(task)"
              @keyup.enter.native="finishEditTaskName(task)"
          />
          <span v-else class="task-name" @dblclick.stop="startEditTaskName(task.id)">{{ task.name }}</span>
          <i v-if="editingTaskId !== task.id" class="el-icon-edit task-edit"
             title="修改任务名" @click.stop="startEditTaskName(task.id)"></i>
          <i class="el-icon-close task-close" @click.stop="deleteTask(task.id)"></i>
        </div>
      </div>
      <el-button v-if="!loopMode && !isH5Page" type="text" size="small" icon="el-icon-video-play"
                 @click="$router.push('/meeting_loop')">循环记录
      </el-button>
      <el-button v-else-if="loopMode && !isH5Page" type="text" size="small" icon="el-icon-back"
                 @click="$router.push('/meeting')">普通记录
      </el-button>
    </div>
    <!--聊天窗口开始（只读，仅展示识别结果） -->
    <div class="Meeting-textarea-wrap">
      <textarea v-model="text"
                readonly
                placeholder="请点击开始记录，记录物品要素~"
                style="height: 560px;width: 100%;padding: 20px; border: none;border-top: 1px solid #ccc;border-bottom: 1px solid #ccc;outline: none">
      </textarea>
    </div>
    <div style="text-align: left;padding-right: 10px;margin-top:240px;">
      <el-button type="primary" size="medium" @click="handleStartClick" :disabled="startBtnDisabled"><i
          class="el-icon-microphone"></i>{{ startBtnText }}
      </el-button>
      <el-button v-if="loopMode" type="danger" size="medium" @click="stopLoopRecording"
                 :disabled="stopBtnDisabled"><i
          class="el-icon-switch-button"></i>停止循环
      </el-button>
      <el-button type="warning" size="medium" @click="handleRevokeButtonClick"
                 :disabled="isStartingRecord || isRecording || loading"><i
          class="el-icon-refresh-left"></i>{{ isH5Page ? '撤销' : '撤销 (B)' }}
      </el-button>
      <span class="vad-eos-label">静音(ms):</span>
      <el-input-number v-model="vadEos" :min="100" :step="100" :precision="0" size="mini"
                       class="vad-eos-input" :disabled="isRecording || isStartingRecord"></el-input-number>
      <span class="vad-eos-label">声贝(dB):</span>
      <el-input-number v-model="soundDb" :min="0" :max="100" :step="5" :precision="0" size="mini"
                       class="vad-eos-input" :disabled="isRecording || isStartingRecord"></el-input-number>
    </div>

    <!-- 上传录音 + 材长输入 + 查看统计（同一行） -->
    <div class="wood-len-row">
      <el-button type="success" size="small" icon="el-icon-upload" @click="uploadAudioManually"
                 :loading="loading" :disabled="loading || isRecording || isStartingRecord">上传录音
      </el-button>
      <span class="wood-len-label">材长:</span>
      <el-input-number v-model="woodLen" :min="0.1" :step="0.1" :precision="2" size="small"
                       class="wood-len-input" @change="onWoodLenChange"></el-input-number>
      <el-button type="primary" size="small" icon="el-icon-data-analysis" @click="openStatDialog">查看统计</el-button>
    </div>

    <!-- 统计弹窗（自实现全屏 modal，H5 避免 el-dialog 关闭按钮被遮挡） -->
    <div v-if="showStatDialog" class="stat-modal-mask" @click.self="showStatDialog = false">
      <div class="stat-modal">
        <div class="stat-modal-header">
          <span class="stat-modal-title">径级统计结果</span>
          <button class="stat-modal-close" type="button" aria-label="关闭" @click="showStatDialog = false">×</button>
        </div>
        <div class="stat-modal-body">
          <pre v-if="statText" class="stat-dialog-pre">{{ statText }}</pre>
          <span v-else class="stat-empty">无统计</span>
        </div>
        <div class="stat-modal-footer">
          <el-button type="primary" size="small" @click="showStatDialog = false">关闭</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CryptoJS from '../../public/crypto-js/crypto-js.js'
import Recorder from '../../public/recorder/index.umd.js'
import * as base64 from 'js-base64'
import Recorder2 from '../js_util/js-audio-recorder';
import {WHITE_IP} from "../../public/config";
import {calcStat} from "@/js_util/statUtil";
import router from "@/js_router/router";

// ==================== 录音通道1：用于听写识别（实时发送音频帧）====================
let iatRecorder = null;           // 听写专用录音器
let iatRecorderInitialized = false;
let iatMediaStream = null;        // 听写录音的MediaStream

// ==================== 录音通道2：用于完整WAV录制（上传用）====================
let wavRecorder = null;           // WAV录制专用录音器
let wavRecorderInitialized = false;
let wavMediaStream = null;        // WAV录制的MediaStream

// ==================== WAV历史录音累积存储（未上传时拼接保存）====================
let accumulatedWAVBuffer = null;  // 累积的历史WAV数据(ArrayBuffer)，上传成功后清空

// 将两个WAV(ArrayBuffer)拼接为一个完整WAV
function concatWAVBuffer(prevBuffer, segBuffer) {
  if (!prevBuffer) return segBuffer;
  const parse = (buf) => {
    const view = new DataView(buf);
    return {
      channels: view.getUint16(22, true),
      sampleRate: view.getUint32(24, true),
      bitsPerSample: view.getUint16(34, true),
      dataSize: view.getUint32(40, true),
      pcm: new Uint8Array(buf.slice(44, 44 + view.getUint32(40, true)))
    };
  };
  const a = parse(prevBuffer);
  const b = parse(segBuffer);
  const blockAlign = a.channels * (a.bitsPerSample / 8);
  const byteRate = a.sampleRate * blockAlign;
  const totalDataSize = a.dataSize + b.dataSize;
  const out = new ArrayBuffer(44 + totalDataSize);
  const view = new DataView(out);
  const bytes = new Uint8Array(out);
  const writeStr = (arr, offset, str) => {
    for (let i = 0; i < str.length; i++) arr[offset + i] = str.charCodeAt(i);
  };
  writeStr(bytes, 0, "RIFF");
  view.setUint32(4, 36 + totalDataSize, true);
  writeStr(bytes, 8, "WAVE");
  writeStr(bytes, 12, "fmt ");
  view.setUint32(16, 16, true);
  view.setUint16(20, 1, true);
  view.setUint16(22, a.channels, true);
  view.setUint32(24, a.sampleRate, true);
  view.setUint32(28, byteRate, true);
  view.setUint16(32, blockAlign, true);
  view.setUint16(34, a.bitsPerSample, true);
  writeStr(bytes, 36, "data");
  view.setUint32(40, totalDataSize, true);
  bytes.set(a.pcm, 44);
  bytes.set(b.pcm, 44 + a.dataSize);
  return out;
}

// ==================== WAV历史持久化（IndexedDB，按任务ID隔离，未上传时跨页面保留）====================
const WAV_DB_NAME = "meeting-db";
const WAV_DB_STORE = "wav-store";
const WAV_DB_LEGACY_KEY = "accumulated-wav";

function wavKey(taskId) {
  return "task-wav-" + taskId;
}

function openWAVDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(WAV_DB_NAME, 1);
    request.onupgradeneeded = () => {
      if (!request.result.objectStoreNames.contains(WAV_DB_STORE)) {
        request.result.createObjectStore(WAV_DB_STORE);
      }
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

async function saveAccumulatedWAV(taskId, buffer) {
  if (!taskId) return;
  try {
    const db = await openWAVDB();
    return new Promise((resolve, reject) => {
      const tx = db.transaction(WAV_DB_STORE, "readwrite");
      tx.objectStore(WAV_DB_STORE).put(buffer, wavKey(taskId));
      tx.oncomplete = () => resolve();
      tx.onerror = () => reject(tx.error);
    });
  } catch (error) {
    console.error("【WAV录音】保存历史失败:", error);
  }
}

async function loadAccumulatedWAV(taskId) {
  if (!taskId) return null;
  try {
    const db = await openWAVDB();
    return new Promise((resolve, reject) => {
      const tx = db.transaction(WAV_DB_STORE, "readonly");
      const req = tx.objectStore(WAV_DB_STORE).get(wavKey(taskId));
      req.onsuccess = () => resolve(req.result || null);
      req.onerror = () => reject(req.error);
    });
  } catch (error) {
    console.error("【WAV录音】读取历史失败:", error);
    return null;
  }
}

async function clearAccumulatedWAV(taskId) {
  if (!taskId) return;
  try {
    const db = await openWAVDB();
    return new Promise((resolve, reject) => {
      const tx = db.transaction(WAV_DB_STORE, "readwrite");
      tx.objectStore(WAV_DB_STORE).delete(wavKey(taskId));
      tx.oncomplete = () => resolve();
      tx.onerror = () => reject(tx.error);
    });
  } catch (error) {
    console.error("【WAV录音】清空历史失败:", error);
  }
}

async function loadAccumulatedWAVLegacy() {
  try {
    const db = await openWAVDB();
    return new Promise((resolve, reject) => {
      const tx = db.transaction(WAV_DB_STORE, "readonly");
      const req = tx.objectStore(WAV_DB_STORE).get(WAV_DB_LEGACY_KEY);
      req.onsuccess = () => resolve(req.result || null);
      req.onerror = () => reject(req.error);
    });
  } catch (error) {
    console.error("【WAV录音】读取旧历史失败:", error);
    return null;
  }
}

async function clearAccumulatedWAVLegacy() {
  try {
    const db = await openWAVDB();
    return new Promise((resolve, reject) => {
      const tx = db.transaction(WAV_DB_STORE, "readwrite");
      tx.objectStore(WAV_DB_STORE).delete(WAV_DB_LEGACY_KEY);
      tx.oncomplete = () => resolve();
      tx.onerror = () => reject(tx.error);
    });
  } catch (error) {
    console.error("【WAV录音】清空旧历史失败:", error);
  }
}

// ==================== 听写录音器实例（通道1）====================
async function getIATRecorderInstance() {
  if (!iatRecorderInitialized) {
    iatRecorder = new Recorder("../../recorder");

    iatRecorder.onStart = () => {
      console.log("【听写录音】开始录音");
    };
    iatRecorder.onStop = () => {
      console.log("【听写录音】停止录音");
    };

    // 添加自定义启动方法，配置回声消除
    iatRecorder.startWithConstraints = function (config) {
      const constraints = {
        audio: {
          echoCancellation: true,
          noiseSuppression: true,
          autoGainControl: false,
          sampleRate: 16000,
          channelCount: 1,
          volume: 1.0
        }
      };
      if (config && config.audio) {
        Object.assign(constraints.audio, config.audio);
      }
      return navigator.mediaDevices.getUserMedia(constraints).then(stream => {
        iatMediaStream = stream;
        return this.start(config);
      });
    };

    iatRecorderInitialized = true;
  }
  return iatRecorder;
}

// ==================== WAV录制录音器实例（通道2）====================
async function getWAVRecorderInstance() {
  if (!wavRecorderInitialized) {
    wavRecorder = new Recorder2({
      sampleBits: 16,
      sampleRate: 16000,
      numChannels: 1,
      echoCancellation: true,
      noiseSuppression: true,
      autoGainControl: false
    });
    wavRecorderInitialized = true;
    console.log("【WAV录音】初始化完成");
  }
  return wavRecorder;
}

// ==================== 通用工具函数 ====================
function toBase64(buffer) {
  let binary = "";
  let bytes = new Uint8Array(buffer);
  let len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
}

let wsFlag = false;
let wsTask = null;

// 语音合成所需的变量
let ttsWS = null;
let audioPlayer = null;

// 全局状态标志
let iatRecordingStarted = false;    // 听写录音是否已启动
let wavRecordingStarted = false;    // WAV录音是否已启动

export default {
  name: "Meeting",
  props: {
    // 循环模式：听写完成后自动开始下一次听写，并显示"停止循环"按钮
    loopMode: {type: Boolean, default: false}
  },
  data() {
    return {
      user: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {},
      URL: 'wss://iat-api.xfyun.cn/v2/iat',
      loading: false,
      isAutoStopping: false,
      isConfirming: false,
      pendingTexts: [],
      isRecording: false,
      isWaitingForNext: false,
      isStartingRecord: false,
      isLoopStopping: false,
      isH5Page: (typeof location !== 'undefined') && location.pathname.includes('h5'),
      needWaitForSpeakComplete: false,
      speakCompleteCallback: null,
      _loopRetryCount: 0,      // 循环模式：连续失败计数（收到识别结果时清零，超限自动停止）
      _sessionEnding: false,   // 标记本轮听写是否已正常收到结束帧（区分正常关闭与异常断开）

      // 多任务管理
      tasks: [], // {id, name, text, accumulatedText, confirmedHistory, canRevoke, createdAt, updatedAt}
      currentTaskId: null,
      editingTaskId: null,

      // 当前任务的运行时数据（从 tasks 中同步）
      text: "",
      accumulatedText: "",
      confirmedHistory: [],
      canRevoke: false,
      resultText: "",
      resultTextTemp: "",

      // 材长输入（默认1）+ 统计弹窗
      woodLen: 6,
      // 讯飞 IAT 服务端 VAD 尾点静音时长(ms)，界面可调，默认 600
      vadEos: 100,
      // 声贝阈值(dB)，界面显示正值(默认30)，内部按 dBFS 负值比较(-30dBFS)
      // 低于阈值的帧替换为同等长度全零静音帧发送（保持音频流连续，不丢弃）
      soundDb: 30,
      showStatDialog: false,
      statText: "",
      // 循环模式运行中标志：启动循环后置 true，停止循环置 false。
      // 用于完全锁定按钮状态——循环运行中循环按钮一直禁用、停止按钮一直可用，
      // 不受 isStartingRecord/isRecording/loading 等状态闪烁影响。
      loopRunning: false,
    }
  },
  computed: {
    // 循环模式按钮文案（PC叫循环记录，H5叫循环录音）
    startBtnText() {
      if (!this.loopMode) return this.isH5Page ? '开始录音' : '开始记录 (A)';
      return this.isH5Page ? '循环录音' : '循环记录 (A)';
    },
    // 循环录音按钮 disabled：循环运行中→一直禁用；否则按原逻辑
    startBtnDisabled() {
      if (this.loopMode && this.loopRunning) return true;
      return this.isStartingRecord || this.loading;
    },
    // 停止循环按钮 disabled：循环运行中→一直可用；未启动→禁用
    stopBtnDisabled() {
      if (this.loopMode && this.loopRunning) return false;
      return true;
    }
  },
  mounted() {
    // 切换账号/重新登录后，确保使用最新的登录用户（任务按 user.name 在 localStorage 中隔离）
    try {
      const loginUserStr = localStorage.getItem("user");
      if (loginUserStr) {
        this.user = JSON.parse(loginUserStr);
      }
    } catch (e) {
      console.warn("读取登录用户信息失败:", e);
    }
    // 添加键盘事件监听：按A键或a键触发开始记录，按B键或b键触发撤销
    this.handleKeyPress = (event) => {
      // 上传过程中禁用 A/B 快捷键
      if (this.loading) return;
      if (event.key === 'a' || event.key === 'A') {
        const activeElement = document.activeElement;
        const isTextArea = activeElement && activeElement.tagName === 'TEXTAREA';
        if (!isTextArea) {
          event.preventDefault();
          if (!this.isStartingRecord && !this.isRecording) {
            this.voiceSend();
          } else if (this.isRecording && wsTask && wsTask.readyState === WebSocket.OPEN) {
            if (wsTask && wsTask.readyState === WebSocket.OPEN) {
              const endParams = {
                data: {
                  status: 2,
                  format: "audio/L16;rate=16000",
                  encoding: "raw",
                  audio: "",
                },
              };
              try {
                wsTask.send(JSON.stringify(endParams));
                this.$message.info("本次听写已结束");
              } catch (error) {
                console.error("发送结束帧失败:", error);
              }
            }
          }
        }
      }
      // 新增：按B键或b键触发撤销
      if (event.key === 'b' || event.key === 'B') {
        const activeElement = document.activeElement;
        const isTextArea = activeElement && activeElement.tagName === 'TEXTAREA';
        if (!isTextArea) {
          event.preventDefault();
          this.handleRevokeButtonClick();
        }
      }
    };
    window.addEventListener('keydown', this.handleKeyPress);

    // 加载多任务列表（含旧版单任务迁移）
    this.loadTasks().then(async () => {
      if (this.tasks.length === 0) {
        await this.createNewTask(false);
      } else {
        // 默认恢复到最后活跃的任务（最后更新的任务）
        const lastTask = [...this.tasks].sort((a, b) => (b.updatedAt || 0) - (a.updatedAt || 0))[0];
        await this.switchTask(lastTask.id, false);
      }
    });

    // 页面加载仅启动听写录音通道；WAV录音在点击“开始记录”时才启动保存
    this.startIATRecording().catch((error) => {
      console.error("初始化录音通道失败:", error);
      this.$message.error("麦克风初始化失败，请检查权限");
    });
  },
  beforeDestroy() {
    if (this.handleKeyPress) {
      window.removeEventListener('keydown', this.handleKeyPress);
    }
    this.isRecording = false;
    this.isStartingRecord = false;
    if (this.confirmTimer) {
      clearTimeout(this.confirmTimer);
      this.confirmTimer = null;
    }
    if (wsTask && wsTask.readyState === WebSocket.OPEN) {
      wsTask.close();
    }
    if (ttsWS && ttsWS.readyState === WebSocket.OPEN) {
      ttsWS.close();
    }

    // 若未上传，结束当前WAV录音片段并按任务ID持久化（供下次进入拼接）
    this.finishCurrentWAVSegment();
    // 保存当前任务状态
    this.saveTasks();
    // 停止所有录音并释放资源
    this.stopAllRecordings();
  },
  methods: {
    reloadPage() {
      window.location.reload();
    },

    // ==================== 多任务管理 ====================
    // 新增任务：调用后端 /task/insertOrUpdate（不带 id → insert），刷新任务列表后切换到最新任务
    async createNewTask(needSave = true) {
      if (!this.user || !this.user.name) {
        this.$message.warning("请先登录");
        return;
      }
      const taskName = "任务 " + (this.tasks.length + 1);
      try {
        const res = await this.$http.post("/task/insertOrUpdate", {
          userName: this.user.name,
          taskName: taskName
        });
        if (res.data.code === "200") {
          // 刷新任务列表（从后端拉取，获取后端生成的 id）
          await this.loadTasks();
          // 切换到最新创建的任务（按 createTime 降序取第一个）
          const latest = [...this.tasks].sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0))[0];
          if (latest) {
            await this.switchTask(latest.id, false);
          }
        } else {
          this.$message.error("创建任务失败: " + (res.data.message || res.data.code));
          if (res.data.code === '401') router.push("/login");
        }
      } catch (e) {
        console.error("创建任务失败:", e);
        this.$message.error("创建任务失败，请检查网络");
      }
    },
    async switchTask(taskId, needSave = true) {
      if (this.currentTaskId === taskId) return;

      // 如果有进行中的录音/听写，先结束并保存到旧任务
      if (this.isRecording || wsFlag || wavRecordingStarted) {
        if (wsTask && wsTask.readyState === WebSocket.OPEN) {
          wsTask.close();
        }
        wsFlag = false;
        this.isRecording = false;
        this.isStartingRecord = false;
        await this.finishCurrentWAVSegment();
      }

      // 保存旧任务状态
      if (needSave) {
        this.saveTasks();
      }

      // 切换当前任务
      this.currentTaskId = taskId;
      accumulatedWAVBuffer = null;
      this.loadTaskData(taskId);
      await this.loadTaskWAV(taskId);

      if (needSave) {
        this.saveTasks();
      }
    },
    startEditTaskName(taskId) {
      this.editingTaskId = taskId;
      // 进入编辑后自动聚焦输入框
      this.$nextTick(() => {
        const ref = this.$refs['taskNameInput_' + taskId];
        const el = Array.isArray(ref) ? ref[0] : ref;
        if (el && el.focus) {
          el.focus();
        }
      });
    },
    // 修改任务名称：调用后端 /task/insertOrUpdate（带 id → updateById）
    async finishEditTaskName(task) {
      this.editingTaskId = null;
      if (!task.name || !task.name.trim()) {
        task.name = "任务 " + (this.tasks.indexOf(task) + 1);
      }
      try {
        await this.$http.post("/task/insertOrUpdate", {
          id: task.id,
          userName: this.user.name,
          taskName: task.name
        });
      } catch (e) {
        console.error("更新任务名失败:", e);
        this.$message.error("更新任务名失败，请检查网络");
      }
    },
    async deleteTask(taskId, needConfirm = true) {
      const idx = this.tasks.findIndex(t => t.id === taskId);
      if (idx === -1) return;

      if (needConfirm) {
        try {
          await this.$confirm('删除后该任务的历史录音和识别结果将不可恢复，是否继续？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          });
        } catch (e) {
          return;
        }
      }

      // 如果删除的是当前任务且正在录音，先结束保存
      if (this.currentTaskId === taskId && (this.isRecording || wavRecordingStarted)) {
        await this.finishCurrentWAVSegment();
      }

      // 调用后端 /task/delete 删除任务记录
      try {
        await this.$http.post("/task/delete", {id: taskId});
      } catch (e) {
        console.error("后端删除任务失败:", e);
      }

      this.tasks.splice(idx, 1);
      // 清理 localStorage 中该任务的运行时数据
      localStorage.removeItem(this.getTaskDataKey(taskId));
      await clearAccumulatedWAV(taskId);

      if (this.currentTaskId === taskId) {
        if (this.tasks.length > 0) {
          const nextIdx = Math.min(idx, this.tasks.length - 1);
          await this.switchTask(this.tasks[nextIdx].id, false);
        } else {
          this.createNewTask(false);
        }
      }
      this.saveTasks();
    },
    // 启动听写录音通道（通道1）- 持续运行，不分片上传
    async startIATRecording() {
      if (iatRecordingStarted) {
        console.log("【听写录音】已在运行中");
        return;
      }

      console.log("【听写录音】首次启动（带回声消除配置）...");
      const recorder = await getIATRecorderInstance();

      // 设置录音帧发送回调 - 只发送给听写WebSocket
      recorder.onFrameRecorded = ({isLastFrame, frameBuffer}) => {
        // 只有当有活动的听写连接且正在听写会话中时，才发送音频数据
        if (!isLastFrame && wsFlag && wsTask && wsTask.readyState === WebSocket.OPEN && this.isRecording) {
          // ===== 声贝(dB)噪音门：参考 Python 实现 =====
          // 计算 dBFS（负值），低于阈值(-soundDb)则替换为同等长度全零静音帧发送（保持音频流连续，不丢弃）
          let sendBuffer = frameBuffer;
          try {
            const samples = new Int16Array(frameBuffer);
            let sum = 0;
            for (let i = 0; i < samples.length; i++) sum += samples[i] * samples[i];
            const rms = Math.sqrt(sum / samples.length);
            const db = rms > 0 ? 20 * Math.log10(rms / 32767) : -100;  // dBFS，负值
            if (db < -this.soundDb) {
              // 低于阈值：替换为同等长度的全零静音帧（不丢弃，保持音频流连续）
              sendBuffer = new ArrayBuffer(frameBuffer.byteLength);
            }
          } catch (e) { /* dB 计算异常不阻塞发送 */ }

          const params = {
            data: {
              status: 1,
              format: "audio/L16;rate=16000",
              encoding: "raw",
              audio: toBase64(sendBuffer),
            },
          };
          try {
            wsTask.send(JSON.stringify(params));
          } catch (error) {
            console.error("发送音频数据失败:", error);
          }
        } else if (isLastFrame && wsFlag && wsTask && wsTask.readyState === WebSocket.OPEN) {
          const params = {
            data: {
              status: 2,
              format: "audio/L16;rate=16000",
              encoding: "raw",
              audio: "",
            },
          };
          console.log("【听写录音】发送最后一帧");
          try {
            wsTask.send(JSON.stringify(params));
          } catch (error) {
            console.error("发送最后一帧失败:", error);
          }
        }
      };

      try {
        if (typeof recorder.startWithConstraints === 'function') {
          await recorder.startWithConstraints({
            sampleRate: 16000,
            frameSize: 1280,
            audio: {
              echoCancellation: true,
              noiseSuppression: true,
              autoGainControl: false
            }
          });
        } else {
          await recorder.start({
            sampleRate: 16000,
            frameSize: 1280,
          });
        }
        iatRecordingStarted = true;
        console.log("【听写录音】已启动，将持续运行");
      } catch (error) {
        console.error("【听写录音】启动失败:", error);
        throw error;
      }
    },

    // 启动WAV录制通道（通道2）- 点击“开始记录”时启动，会话结束保存片段
    async startWAVRecording() {
      if (wavRecordingStarted) {
        console.log("【WAV录音】已在运行中");
        return;
      }

      console.log("【WAV录音】启动新录音片段...");
      const recorder = await getWAVRecorderInstance();

      try {
        await Recorder2.getPermission();
        // 启动WAV录音（不设置回调，只录制当前会话片段）
        recorder.start();
        wavRecordingStarted = true;
        console.log("【WAV录音】已启动");
      } catch (error) {
        console.error("【WAV录音】启动失败:", error);
        // WAV录音失败不影响听写功能
        this.$message.warning("WAV录音启动失败，但听写功能可用");
      }
    },

    // 停止所有录音并释放资源
    async stopAllRecordings() {
      // 停止听写录音（讯飞Recorder无isRecording属性，用模块级标志判断）
      if (iatRecordingStarted && iatRecorder) {
        iatRecorder.stop();
        iatRecordingStarted = false;
        console.log("【听写录音】已停止");
      }
      if (iatMediaStream) {
        iatMediaStream.getTracks().forEach(track => track.stop());
        iatMediaStream = null;
      }
      // 重置听写录音器实例，保证下次进入页面时重新初始化
      iatRecorderInitialized = false;
      iatRecorder = null;

      // 停止WAV录音（js-audio-recorder属性名为小写isrecording，用模块级标志判断）
      if (wavRecordingStarted && wavRecorder) {
        wavRecorder.stop();
        wavRecordingStarted = false;
        console.log("【WAV录音】已停止");
      }
      if (wavMediaStream) {
        wavMediaStream.getTracks().forEach(track => track.stop());
        wavMediaStream = null;
      }
      // 重置WAV录音器实例，保证下次进入页面时重新初始化
      wavRecorderInitialized = false;
      wavRecorder = null;
    },

    // 结束当前WAV录音片段并拼接到历史WAV（按当前任务ID持久化保存）
    async finishCurrentWAVSegment() {
      if (!wavRecordingStarted || !wavRecorder) {
        wavRecordingStarted = false;
        return;
      }
      try {
        wavRecorder.stop();
        const segBlob = wavRecorder.getWAVBlob();
        if (segBlob && segBlob.size > 44) {
          const segBuffer = await segBlob.arrayBuffer();
          accumulatedWAVBuffer = concatWAVBuffer(accumulatedWAVBuffer, segBuffer);
          if (this.currentTaskId) {
            await saveAccumulatedWAV(this.currentTaskId, accumulatedWAVBuffer);
          }
          console.log("【WAV录音】片段已保存并拼接，累计大小:", accumulatedWAVBuffer.byteLength, "字节");
        }
      } catch (error) {
        console.error("【WAV录音】保存片段失败:", error);
      } finally {
        wavRecordingStarted = false;
      }
    },

    // TTS播放期间暂停WAV录音，避免把扬声器播出的提示音录进wav造成回音
    pauseWAVRecordingForSpeak() {
      if (wavRecordingStarted && wavRecorder && wavRecorder.isrecording && !wavRecorder.ispause) {
        wavRecorder.pause();
        console.log("【WAV录音】TTS播放期间已暂停录制");
      }
    },
    // TTS播放结束后恢复WAV录音
    resumeWAVRecordingAfterSpeak() {
      if (wavRecordingStarted && wavRecorder && wavRecorder.isrecording && wavRecorder.ispause) {
        wavRecorder.resume();
        console.log("【WAV录音】TTS播放结束，恢复录制");
      }
    },

    // ==================== 语音合成相关 ====================
    async speakText(text, onComplete = null) {
      if (onComplete) {
        this.speakCompleteCallback = onComplete;
      }
      return new Promise((resolve, reject) => {
        // 兜底：TTS 在某些情况下（鉴权失败、网络异常）onmessage 永不触发 resolve，
        // 会导致循环模式 handleListenComplete 不调用、循环永久卡住。
        // 这里 10 秒兜底强制推进流程，避免循环中断。
        const fallbackTimer = setTimeout(() => {
          console.warn("【TTS】超时兜底，强制结束");
          this.resumeWAVRecordingAfterSpeak();
          if (ttsWS && ttsWS.readyState <= 1) {
            try {
              ttsWS.close();
            } catch (e) { /* ignore */
            }
          }
          resolve();
          if (this.speakCompleteCallback) {
            try {
              this.speakCompleteCallback();
            } catch (e) {
              console.error(e);
            }
            this.speakCompleteCallback = null;
          }
        }, 10000);
        this._speakFallbackTimer = fallbackTimer;

        if (!audioPlayer) {
          import('../../public/player/index.umd.js').then(module => {
            const AudioPlayer = module.default;
            audioPlayer = new AudioPlayer("../../player");
            this.doSpeak(text, resolve, reject);
          }).catch(err => {
            console.error("加载AudioPlayer失败:", err);
            clearTimeout(fallbackTimer);
            reject(err);
            if (this.speakCompleteCallback) {
              this.speakCompleteCallback();
              this.speakCompleteCallback = null;
            }
          });
        } else {
          this.doSpeak(text, resolve, reject);
        }
      });
    },

    doSpeak(text, resolve, reject) {
      // TTS播放期间暂停WAV录音，避免提示音被录进wav造成回音
      this.pauseWAVRecordingForSpeak();

      const apiKey = atob(this.user.apikey);
      const apiSecret = atob(this.user.apisecret);
      const url = this.getTtsWebSocketUrl(apiKey, apiSecret);

      if (!("WebSocket" in window)) {
        alert("浏览器不支持WebSocket");
        this.resumeWAVRecordingAfterSpeak();
        if (this._speakFallbackTimer) {
          clearTimeout(this._speakFallbackTimer);
          this._speakFallbackTimer = null;
        }
        reject(new Error("WebSocket not supported"));
        if (this.speakCompleteCallback) {
          this.speakCompleteCallback();
          this.speakCompleteCallback = null;
        }
        return;
      }

      ttsWS = new WebSocket(url);
      let isStarted = false;

      ttsWS.onopen = () => {
        console.log("TTS WebSocket 连接成功");
        audioPlayer.start({
          autoPlay: true,
          sampleRate: 16000,
          resumePlayDuration: 1000
        });

        let params = {
          "header": {
            "app_id": atob(this.user.appid),
            "status": 2
          },
          "parameter": {
            "oral": {
              "spark_assist": 0
            },
            "tts": {
              "vcn": "x4_lingxiaoxuan_oral",
              "volume": 50,
              "speed": 50,
              "pitch": 50,
              "bgs": 0,
              "reg": 0,
              "rdn": 2,
              "audio": {
                "encoding": "raw",
                "sample_rate": 16000,
                "channels": 1,
                "bit_depth": 16,
                "frame_size": 0
              }
            }
          },
          "payload": {
            "text": {
              "encoding": "utf8",
              "compress": "raw",
              "format": "plain",
              "status": 2,
              "seq": 0,
              "text": base64.encode(text),
            }
          }
        };
        ttsWS.send(JSON.stringify(params));
        console.log("TTS 请求发送成功");
      };

      ttsWS.onmessage = (e) => {
        let jsonData = JSON.parse(e.data);
        console.log("TTS 返回数据:", jsonData);
        if (jsonData.header.code !== 0) {
          console.error("TTS合成失败:", jsonData);
          this.resumeWAVRecordingAfterSpeak();
          if (this._speakFallbackTimer) {
            clearTimeout(this._speakFallbackTimer);
            this._speakFallbackTimer = null;
          }
          reject(new Error("TTS合成失败"));
          ttsWS.close();
          if (this.speakCompleteCallback) {
            this.speakCompleteCallback();
            this.speakCompleteCallback = null;
          }
          return;
        }
        if (jsonData.payload && jsonData.payload.audio && jsonData.payload.audio.audio) {
          audioPlayer.postMessage({
            type: "base64",
            data: jsonData.payload.audio.audio,
            isLastData: jsonData.header.status === 2,
          });
          if (!isStarted) {
            isStarted = true;
          }
        }
        if (jsonData.header.code === 0 && jsonData.header.status === 2) {
          setTimeout(() => {
            ttsWS.close();
            // TTS播放结束，恢复WAV录音
            this.resumeWAVRecordingAfterSpeak();
            if (this._speakFallbackTimer) {
              clearTimeout(this._speakFallbackTimer);
              this._speakFallbackTimer = null;
            }
            resolve();
            if (this.speakCompleteCallback) {
              this.speakCompleteCallback();
              this.speakCompleteCallback = null;
            }
          }, 500);
        }
      };

      ttsWS.onerror = (e) => {
        console.error("TTS WebSocket错误:", e);
        this.resumeWAVRecordingAfterSpeak();
        if (this._speakFallbackTimer) {
          clearTimeout(this._speakFallbackTimer);
          this._speakFallbackTimer = null;
        }
        reject(e);
        if (this.speakCompleteCallback) {
          this.speakCompleteCallback();
          this.speakCompleteCallback = null;
        }
      };

      ttsWS.onclose = () => {
        console.log("TTS WebSocket关闭");
      };
    },

    getTtsWebSocketUrl(apiKey, apiSecret) {
      let url = "wss://cbm01.cn-huabei-1.xf-yun.com/v1/private/mcd9m97e6";
      let host = location.host;
      let date = new Date().toGMTString();
      let algorithm = "hmac-sha256";
      let headers = "host date request-line";
      let signatureOrigin = `host: ${host}\ndate: ${date}\nGET /v1/private/mcd9m97e6 HTTP/1.1`;
      let signatureSha = CryptoJS.HmacSHA256(signatureOrigin, apiSecret);
      let signature = CryptoJS.enc.Base64.stringify(signatureSha);
      let authorizationOrigin = `api_key="${apiKey}", algorithm="${algorithm}", headers="${headers}", signature="${signature}"`;
      let authorization = btoa(authorizationOrigin);
      url = `${url}?authorization=${authorization}&date=${date}&host=${host}`;
      return url;
    },

    // ==================== 听写WebSocket相关 ====================
    getWebSocketUrl() {
      return new Promise((resolve, reject) => {
        var url = this.URL;
        var host = "iat-api.xfyun.cn";
        var apiKeyName = "api_key";
        var date = new Date().toGMTString();
        var algorithm = "hmac-sha256";
        var headers = "host date request-line";
        var signatureOrigin = `host: ${host}\ndate: ${date}\nGET /v2/iat HTTP/1.1`;
        var signatureSha = CryptoJS.HmacSHA256(signatureOrigin, atob(this.user.apisecret));
        var signature = CryptoJS.enc.Base64.stringify(signatureSha);
        var authorizationOrigin =
            `${apiKeyName}="${atob(this.user.apikey)}", algorithm="${algorithm}", headers="${headers}", signature="${signature}"`;
        var authorization = base64.encode(authorizationOrigin);
        url = `${url}?authorization=${authorization}&date=${encodeURI(date)}&host=${host}`;
        console.log(url)
        resolve(url);
      });
    },

    sendStartFrame() {
      if (!wsTask || wsTask.readyState !== WebSocket.OPEN) {
        console.log("WebSocket未连接，无法发送开始帧");
        return false;
      }

      let params = {
        common: {
          app_id: atob(this.user.appid),
        },
        business: {
          language: "zh_cn",
          domain: "open-ed",
          accent: "mandarin",
          vad_eos: this.vadEos || 100,  // 界面可调，默认 600ms
          dwa: "wpgs",
        },
        data: {
          status: 0,
          format: "audio/L16;rate=16000",
          encoding: "raw",
        },
      };
      console.log("发送第一帧数据...");
      try {
        wsTask.send(JSON.stringify(params));
        return true;
      } catch (error) {
        console.error("发送开始帧失败:", error);
        return false;
      }
    },

    async wsInit() {
      this.$message.success("已开始语音听写...")
      var _this = this;

      if (typeof (WebSocket) == 'undefined') {
        console.log('您的浏览器不支持ws...')
        this.$message.error("浏览器不支持WebSocket");
        this.isStartingRecord = false;
        return;
      }

      console.log('您的浏览器支持ws！！！')

      let reqeustUrl;
      try {
        reqeustUrl = await _this.getWebSocketUrl();
      } catch (error) {
        console.error("获取WebSocket地址失败:", error);
        this.$message.error("初始化失败，请重试");
        this.isStartingRecord = false;
        this.isRecording = false;
        this.finishCurrentWAVSegment();
        if (this.loopMode && !this.isLoopStopping) {
          this.scheduleLoopRestart(2000);
        }
        return;
      }

      wsTask = new WebSocket(reqeustUrl);
      this._sessionEnding = false; // 新连接：重置"正常结束"标记
      wsFlag = true;

      wsTask.onopen = function () {
        console.log('ws已经打开...')
        _this.sendStartFrame();
      }

      wsTask.onmessage = function (message) {
        try {
          let jsonData = JSON.parse(message.data);

          if (jsonData.code !== 0) {
            // 讯飞返回错误码（如并发超限/鉴权失败等）：必须清理状态，否则循环会卡死
            console.error("听写出错:", jsonData);
            try {
              if (wsTask && wsTask.readyState === WebSocket.OPEN) wsTask.close();
            } catch (e) { /* ignore */
            }
            wsFlag = false;
            _this.isRecording = false;
            _this.isStartingRecord = false;
            _this.finishCurrentWAVSegment();
            _this.$message.error("听写服务错误(" + (jsonData.code || "") + ")，" + (jsonData.message || "请稍候自动重试"));
            if (_this.loopMode && !_this.isLoopStopping) {
              _this.scheduleLoopRestart(2000);
            }
            return;
          }

          if (jsonData.data && jsonData.data.result) {
            // 收到有效识别结果，重置循环失败计数
            _this._loopRetryCount = 0;
            let data = jsonData.data.result;
            let str = "";
            let ws = data.ws;
            for (let i = 0; i < ws.length; i++) {
              str = str + ws[i].cw[0].w;
            }

            if (data.pgs) {
              if (data.pgs === "apd") {
                _this.resultText = _this.resultTextTemp;
              }
              _this.resultTextTemp = _this.resultText + str;
            } else {
              _this.resultText = _this.resultText + str;
            }

            const currentText = _this.resultTextTemp || _this.resultText || "";
            _this.text = currentText;
          }

          if (jsonData.data && jsonData.data.status === 2) {
            console.log("本次听写结束，status=2");
            _this._sessionEnding = true; // 标记本轮为正常结束，onclose 不再按异常断开重试

            const finalText = _this.resultTextTemp || _this.resultText || "";
            console.log("本次听写最终结果:", finalText);

            // 听写处理/播报完成后统一回调：恢复按钮状态；循环模式下自动开始下一次听写
            // 重启间隔 1.5 秒：给讯飞服务端释放上一条连接的时间，避免撞并发连接限制
            const handleListenComplete = () => {
              _this.isStartingRecord = false;
              if (_this.loopMode && !_this.isLoopStopping) {
                console.log("【循环模式】本次听写完成，自动开始下一次听写");
                setTimeout(() => {
                  if (_this.loopMode && !_this.isLoopStopping && !_this.loading) {
                    _this.voiceSend();
                  }
                }, 1500);
              }
            };

            if (finalText && finalText.trim()) {
              _this.processFormattedResult(finalText, handleListenComplete);
            } else {
              _this.text = _this.accumulatedText;
              handleListenComplete();
            }

            _this.resultText = "";
            _this.resultTextTemp = "";

            console.log("听写结束，关闭当前听写连接");
            if (wsTask && wsTask.readyState === WebSocket.OPEN) {
              wsTask.close();
            }
            wsFlag = false;
            _this.isRecording = false;
            // 本次听写会话结束，结束当前WAV录音片段并拼接保存
            _this.finishCurrentWAVSegment();
            if (_this.loopMode) {
              if (!_this.isLoopStopping) {
                _this.$message.success("本次听写完成，自动进入下一次循环");
              }
            } else {
              _this.$message.info("本次听写已完成，如需继续请再次点击开始记录");
            }
          }
        } catch (error) {
          console.error("处理WebSocket消息失败:", error);
          _this.isStartingRecord = false;
        }
      }

      wsTask.onclose = function () {
        console.log('ws已关闭...')
        const endedNormally = _this._sessionEnding;
        _this._sessionEnding = false;
        wsFlag = false;
        if (_this.isStartingRecord) {
          console.log("WebSocket异常关闭，恢复按钮状态");
          _this.isStartingRecord = false;
        }
        // 异常断开（未收到结束帧）且循环模式：清理状态并自动重试下一轮
        if (!endedNormally && _this.loopMode && !_this.isLoopStopping && _this.isRecording) {
          console.warn("【循环模式】听写连接异常断开，稍后自动重试");
          _this.isRecording = false;
          _this.finishCurrentWAVSegment();
          _this.scheduleLoopRestart(2000);
        }
      }

      wsTask.onerror = function (error) {
        console.log('发生错误:', error)
        wsFlag = false;
        _this.isRecording = false;
        _this.isStartingRecord = false;
        _this.finishCurrentWAVSegment();
        _this.$message.error("WebSocket连接错误，请重试");
        if (_this.loopMode && !_this.isLoopStopping) {
          _this.scheduleLoopRestart(2000);
        }
      }
    },

    async voiceSend() {
      if (this.loading) {
        this.$message.warning("正在上传音频，请稍后...");
        return;
      }
      if (this.isStartingRecord) {
        console.log("正在开始记录中，请勿重复点击");
        this.$message.warning("正在开始记录中，请稍后...");
        return;
      }

      if (this.isRecording || (wsTask && wsTask.readyState === WebSocket.OPEN)) {
        console.log("检测到已有进行中的会话，先停止当前会话");
        this.$message.info("正在停止当前会话，请稍后再试");

        if (wsTask && wsTask.readyState === WebSocket.OPEN) {
          wsTask.close();
        }
        wsFlag = false;
        this.isRecording = false;

        await new Promise(resolve => setTimeout(resolve, 500));
      }

      this.isStartingRecord = true;

      try {
        if (wsTask && wsTask.readyState === WebSocket.OPEN) {
          console.log("关闭现有听写连接，重新开始新的听写会话");
          wsTask.close();
          wsFlag = false;
          await new Promise(resolve => setTimeout(resolve, 300));
        }

        this.resultText = "";
        this.resultTextTemp = "";
        this.isAutoStopping = false;
        this.isConfirming = false;
        this.pendingTexts = [];
        this.isWaitingForNext = true;
        this.isRecording = true;

        if (this.confirmTimer) {
          clearTimeout(this.confirmTimer);
          this.confirmTimer = null;
        }

        // 开启语音听写前先播放合成"叮"提示音（失败不阻塞听写启动）
        try {
          await this.playStartSound();
        } catch (e) {
          console.warn("播放开始提示音失败，继续启动听写:", e);
        }

        // 确保听写录音通道已启动
        await this.startIATRecording();

        // 点击“开始记录”后再启动WAV录音并保存
        await this.startWAVRecording();

        // 建立新的听写WebSocket连接
        await this.wsInit();

        setTimeout(() => {
          if (this.isStartingRecord) {
            console.log("超时自动恢复按钮状态");
            this.isStartingRecord = false;
          }
        }, 30000);

      } catch (error) {
        console.error("开始记录失败:", error);
        this.$message.error("开始记录失败，请重试");
        this.isStartingRecord = false;
        this.isRecording = false;
        // 会话未成功建立，结束当前WAV录音片段，避免残留
        this.finishCurrentWAVSegment();
      }
    },

    async stopVoice(isAuto = false) {
      if (this.confirmTimer) {
        clearTimeout(this.confirmTimer);
        this.confirmTimer = null;
      }

      this.isRecording = false;
      this.isWaitingForNext = false;

      if (wsTask && wsTask.readyState === WebSocket.OPEN) {
        wsTask.close();
      }
      wsFlag = false;

      if (!isAuto) {
        const tip = this.loopMode ? "已停止循环记录" : "已停止记录";
        this.$message.success(tip);
        await this.speakText(tip, () => {
          this.isStartingRecord = false;
        });
      }

      if (isAuto) {
        await this.speakText("你好，已经停止记录，将自动上传", async () => {
          await this.uploadWAVData();
          setTimeout(() => {
            window.location.reload();
          }, 2500);
        });
      }
    },

    async uploadAudioManually() {
      if (!this.accumulatedText || this.accumulatedText === "") {
        this.$message.warning("没有可上传的记录内容");
        return;
      }
      await this.speakText("正在上传记录");
      await this.uploadWAVData();
    },

    // 材长变更：弹窗打开时实时重算统计文本
    onWoodLenChange() {
      if (this.showStatDialog) {
        this.statText = calcStat(this.accumulatedText, this.woodLen);
      }
    },

    // 打开统计弹窗
    openStatDialog() {
      this.statText = calcStat(this.accumulatedText, this.woodLen);
      this.showStatDialog = true;
    },

    // 径级分段统计算法已抽离到 @/js_util/statUtil 公共模块，与 ZDocument.vue 共用
    // ==================== 循环模式 ====================
    // 循环模式下点击主按钮：清除停止标记并启动听写
    handleStartClick() {
      if (this.loopMode) {
        this.isLoopStopping = false;
        this._loopRetryCount = 0;
        // 循环已启动：锁定按钮状态（循环按钮一直禁用、停止按钮一直可用，不受每轮听写状态影响）
        this.loopRunning = true;
      }
      this.voiceSend();
    },

    // 循环模式：延迟自动重启下一轮听写（带停止/上传双重校验，连续失败超限自动停止）
    scheduleLoopRestart(delay = 1500) {
      if (!this.loopMode || this.isLoopStopping || this.loading) return;
      this._loopRetryCount++;
      if (this._loopRetryCount > 5) {
        console.error("【循环模式】连续失败次数过多，自动停止循环");
        this.isLoopStopping = true;
        this.loopRunning = false;
        this.$message.error("听写连续失败次数过多，已停止循环，请检查网络后重试");
        return;
      }
      console.log(`【循环模式】将在${delay}ms后自动开始下一轮听写（第${this._loopRetryCount}次重试）`);
      setTimeout(() => {
        if (this.loopMode && !this.isLoopStopping && !this.loading) {
          this.voiceSend();
        }
      }, delay);
    },

    // 循环模式：终止循环听写录音
    async stopLoopRecording() {
      if (this.loading) {
        this.$message.warning("正在上传音频，请稍后...");
        return;
      }
      this.isLoopStopping = true;
      // 循环已停止：恢复按钮状态（循环按钮可用、停止按钮禁用）
      this.loopRunning = false;
      this.$message.success("正在停止循环录音...");
      await this.stopVoice(false);
    },

    // 开始听写提示音：用 Web Audio API 合成清脆"叮"（1200Hz 正弦波，0.25秒，指数衰减）
    playStartSound(onComplete = null) {
      return new Promise((resolve) => {
        const done = () => {
          if (onComplete) {
            try {
              onComplete();
            } catch (e) { /* ignore */
            }
          }
          resolve();
        };
        try {
          const AudioCtx = window.AudioContext || window.webkitAudioContext;
          if (!AudioCtx) {
            done();
            return;
          }
          const ctx = new AudioCtx();
          const osc = ctx.createOscillator();
          const gain = ctx.createGain();
          osc.type = 'sine';
          osc.frequency.setValueAtTime(1200, ctx.currentTime);
          // 清脆"叮"：快速起音 + 指数衰减
          gain.gain.setValueAtTime(0, ctx.currentTime);
          gain.gain.linearRampToValueAtTime(0.3, ctx.currentTime + 0.01);
          gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.25);
          osc.connect(gain);
          gain.connect(ctx.destination);
          const fallback = setTimeout(done, 400);
          osc.onended = () => {
            clearTimeout(fallback);
            try {
              ctx.close();
            } catch (e) { /* ignore */
            }
            done();
          };
          osc.start();
          osc.stop(ctx.currentTime + 0.25);
        } catch (e) {
          console.warn("播放开始提示音失败:", e);
          done();
        }
      });
    },

    // 识别失败提示音：用 Web Audio API 合成低沉"嘟"（350Hz 方波，0.45秒，平稳后衰减）
    playErrSound(onComplete = null) {
      return new Promise((resolve) => {
        const done = () => {
          if (onComplete) {
            try {
              onComplete();
            } catch (e) { /* ignore */
            }
          }
          resolve();
        };
        try {
          const AudioCtx = window.AudioContext || window.webkitAudioContext;
          if (!AudioCtx) {
            done();
            return;
          }
          const ctx = new AudioCtx();
          const osc = ctx.createOscillator();
          const gain = ctx.createGain();
          osc.type = 'square';
          osc.frequency.setValueAtTime(350, ctx.currentTime);
          // 低沉"嘟"：起音后平稳 0.3 秒再衰减
          gain.gain.setValueAtTime(0, ctx.currentTime);
          gain.gain.linearRampToValueAtTime(0.25, ctx.currentTime + 0.02);
          gain.gain.setValueAtTime(0.25, ctx.currentTime + 0.3);
          gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.45);
          osc.connect(gain);
          gain.connect(ctx.destination);
          const fallback = setTimeout(done, 600);
          osc.onended = () => {
            clearTimeout(fallback);
            try {
              ctx.close();
            } catch (e) { /* ignore */
            }
            done();
          };
          osc.start();
          osc.stop(ctx.currentTime + 0.45);
        } catch (e) {
          console.warn("播放错误提示音失败:", e);
          done();
        }
      });
    },

    // 出错提示：固定电子音（0.2秒），替代原来的"嘟~"人声
    playBeep(onComplete = null) {
      this.pauseWAVRecordingForSpeak();
      return new Promise((resolve) => {
        let finished = false;
        const done = () => {
          if (finished) return;
          finished = true;
          this.resumeWAVRecordingAfterSpeak();
          if (onComplete) {
            try {
              onComplete();
            } catch (e) {
              console.error(e);
            }
          }
          resolve();
        };
        // 兜底：300ms 后无论 osc.onended 是否触发都强制结束，
        // 避免浏览器兼容性问题导致 done() 永不调用，进而导致循环模式下 handleListenComplete 不触发、循环中断
        const fallbackTimer = setTimeout(done, 300);
        try {
          const AudioCtx = window.AudioContext || window.webkitAudioContext;
          if (!AudioCtx) {
            clearTimeout(fallbackTimer);
            done();
            return;
          }
          const ctx = new AudioCtx();
          const osc = ctx.createOscillator();
          const gain = ctx.createGain();
          osc.type = 'square';
          osc.frequency.value = 1000;
          gain.gain.setValueAtTime(0.25, ctx.currentTime);
          gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.2);
          osc.connect(gain);
          gain.connect(ctx.destination);
          osc.onended = () => {
            clearTimeout(fallbackTimer);
            try {
              ctx.close();
            } catch (e) { /* ignore */
            }
            done();
          };
          osc.start();
          osc.stop(ctx.currentTime + 0.2);
        } catch (e) {
          console.error("播放提示音失败:", e);
          clearTimeout(fallbackTimer);
          done();
        }
      });
    },

    // ==================== 格式处理相关 ====================
    // 提炼"数字…确认词"对，容忍数字与确认词之间任意干扰字符
    // 循环识别1（loopMode=false，确认词"加"）："17加 18加" → 17、18
    // 循环识别2（loopMode=true，确认词"确认"）："17确认 18确认" → 17、18
    parseAndExtractContent(text) {
      const matches = [];
      const regex = this.loopMode
        // 循环识别2：数字 + 任意非"确"字符(懒惰) + "确" + 可选标点/空格 + "认"
        ? /(\d+|(?:零|一|二|三|四|五|六|七|八|九|十|百|千|万|亿)+)[^确]*?确[\s,，。、？?]*认/g
        // 循环识别1：数字 + 任意非"加"字符(懒惰) + "加"
        : /(\d+|(?:零|一|二|三|四|五|六|七|八|九|十|百|千|万|亿)+)[^加]*?加/g;
      let match;
      while ((match = regex.exec(text)) !== null) {
        if (match[1]) matches.push(match[1]);
      }
      return matches;
    },

    // 合法格式：能提炼出至少一个"数字…确认词"对
    isValidFormat(text) {
      const cleanText = text.replace(/\s/g, '');
      return this.parseAndExtractContent(cleanText).length > 0;
    },

    processItemText(item) {
      const map = {
        '零': '0', '一': '1', '二': '2', '三': '3', '四': '4',
        '五': '5', '六': '6', '七': '7', '八': '8', '九': '9', '十': '10'
      };
      let processed = item.replace(/[零一二三四五六七八九十]/g, match => map[match]);
      processed = processed.replaceAll('，', '').replaceAll('。', '');
      return processed;
    },

    combineItems(items) {
      if (!items || items.length === 0) return '';
      if (items.length === 1) return items[0];
      return items.join(' ');
    },

    async processFormattedResult(text, onComplete = null) {
      console.log("处理格式化结果:", text);

      if (!this.isAutoStopping && (text.includes("停止记录") || text.includes("停止"))) {
        this.isAutoStopping = true;
        this.stopVoice(true);
        if (onComplete) onComplete();
        return false;
      }

      if (text.includes("撤销记录") || text.includes("撤销")) {
        console.log("检测到撤销指令");
        await this.handleRevokeCommand(text);
        if (onComplete) onComplete();
        return false;
      }

      text = text.replaceAll("。", "").replaceAll(",", "").replaceAll('？', '');
      if (!this.isValidFormat(text)) {
        console.log("不符合格式要求，不进行记录:", text);
        await this.playErrSound(onComplete);
        this.text = this.accumulatedText;
        return false;
      }

      const extractedContents = this.parseAndExtractContent(text);
      if (extractedContents.length === 0) {
        console.log("未提取到有效内容");
        await this.playErrSound(onComplete);
        this.text = this.accumulatedText;
        return false;
      }

      console.log("提取到的内容:", extractedContents);
      this.pendingTexts = extractedContents;
      this.isConfirming = true;
      await this.batchConfirmItems(onComplete);
      return true;
    },

    async batchConfirmItems(onComplete = null) {
      if (this.pendingTexts.length === 0) {
        this.isConfirming = false;
        console.log("没有需要确的项目");
        if (onComplete) onComplete();
        return;
      }

      let combinedItem = this.combineItems(this.pendingTexts);
      combinedItem = this.processItemText(combinedItem);
      let confirmText = combinedItem;

      console.log("批量确提示:", confirmText);
      await this.speakText(confirmText);

      if (this.confirmTimer) {
        clearTimeout(this.confirmTimer);
      }

      this.confirmTimer = setTimeout(async () => {
        if (this.isConfirming && this.pendingTexts.length > 0) {
          console.log("等待超时，自动记录内容:", combinedItem);
          this.accumulatedText += combinedItem + ";";
          this.text = this.accumulatedText;
          this.confirmedHistory.push(combinedItem);
          this.canRevoke = true;
          this.pendingTexts = [];
          this.isConfirming = false;
          this.savePersistedHistory();
          if (onComplete) onComplete();
        }
      }, 1000);
    },

    async confirmAllItems() {
      if (!this.isConfirming || this.pendingTexts.length === 0) {
        console.log("没有待确的项目");
        return false;
      }

      console.log("确记录所有内容:", this.pendingTexts);
      if (this.confirmTimer) {
        clearTimeout(this.confirmTimer);
        this.confirmTimer = null;
      }

      const combinedItem = this.combineItems(this.pendingTexts);
      const processedItem = this.processItemText(combinedItem);
      this.accumulatedText += processedItem + ";";
      this.text = this.accumulatedText;
      this.confirmedHistory.push(processedItem);
      this.canRevoke = true;
      const recordedCount = this.pendingTexts.length;
      this.pendingTexts = [];
      this.isConfirming = false;
      this.savePersistedHistory();
      await this.speakText(`已记录${recordedCount}项内容`);
      return true;
    },

    async revokeAllItems() {
      if (!this.isConfirming || this.pendingTexts.length === 0) {
        console.log("没有待删除的项目");
        return false;
      }

      console.log("删除所有待确内容:", this.pendingTexts);
      if (this.confirmTimer) {
        clearTimeout(this.confirmTimer);
        this.confirmTimer = null;
      }

      const revokedCount = this.pendingTexts.length;
      this.pendingTexts = [];
      this.isConfirming = false;
      await this.speakText(`已删除${revokedCount}项内容`);
      return true;
    },

    // 新增：撤销按钮点击处理方法
    async handleRevokeButtonClick() {
      if (this.loading) {
        this.$message.warning("正在上传音频，请稍后...");
        return;
      }
      // 如果正在录音或正在开始记录，提示用户
      if (this.isStartingRecord) {
        this.$message.warning("正在开始记录中，请稍后...");
        return;
      }

      if (this.isRecording) {
        this.$message.warning("正在录音中，请先停止录音再撤销");
        return;
      }

      // 检查是否有可撤销的内容
      if (this.confirmedHistory.length === 0 && this.pendingTexts.length === 0) {
        this.$message.warning("没有可撤销的记录");
        await this.speakText("没有可撤销的记录");
        return;
      }

      // 如果有待确认的项目，先撤销待确认的项目
      if (this.isConfirming && this.pendingTexts.length > 0) {
        console.log("撤销整个批次的待确认项目:", this.pendingTexts);
        if (this.confirmTimer) {
          clearTimeout(this.confirmTimer);
          this.confirmTimer = null;
        }
        const revokedCount = this.pendingTexts.length;
        this.pendingTexts = [];
        this.isConfirming = false;
        this.$message.success(`已删除${revokedCount}项未确认内容`);
        await this.speakText(`已删除${revokedCount}项未确认内容`);
        return;
      }

      // 否则撤销已确认的最后一条记录
      if (this.confirmedHistory.length === 0) {
        this.$message.warning("没有可撤销的记录");
        await this.speakText("没有可撤销的记录");
        return;
      }

      const lastItem = this.confirmedHistory.pop();
      console.log("撤销最后一条记录:", lastItem);
      const toRemove = lastItem + ";";
      if (this.accumulatedText.endsWith(toRemove)) {
        this.accumulatedText = this.accumulatedText.slice(0, -toRemove.length);
      } else {
        const lastIndex = this.accumulatedText.lastIndexOf(lastItem);
        if (lastIndex !== -1) {
          this.accumulatedText = this.accumulatedText.substring(0, lastIndex);
          if (this.accumulatedText.endsWith(";")) {
            this.accumulatedText = this.accumulatedText.slice(0, -1);
          }
        } else {
          const parts = this.accumulatedText.split(";").filter(p => p.trim());
          if (parts.length > 0) {
            parts.pop();
            this.accumulatedText = parts.join(";");
            if (this.accumulatedText) this.accumulatedText += ";";
          }
        }
      }

      this.text = this.accumulatedText;
      this.canRevoke = this.confirmedHistory.length > 0;
      this.savePersistedHistory();
      this.$message.success(`已删除${lastItem}`);
      await this.speakText(`已删除${lastItem}`);
    },

    // 原有的撤销处理逻辑（保留用于语音指令）
    async handleRevokeCommand(recognizedText) {
      if (this.isConfirming && this.pendingTexts.length > 0) {
        console.log("撤销整个批次的待确项目:", this.pendingTexts);
        if (this.confirmTimer) {
          clearTimeout(this.confirmTimer);
          this.confirmTimer = null;
        }
        const revokedCount = this.pendingTexts.length;
        this.pendingTexts = [];
        this.isConfirming = false;
        await this.speakText(`已删除${revokedCount}项未确内容`);
        return true;
      }

      if (this.confirmedHistory.length === 0) {
        console.log("没有可撤销的记录");
        await this.speakText("没有可撤销的记录");
        return false;
      }

      const lastItem = this.confirmedHistory.pop();
      console.log("撤销最后一条记录:", lastItem);
      const toRemove = lastItem + ";";
      if (this.accumulatedText.endsWith(toRemove)) {
        this.accumulatedText = this.accumulatedText.slice(0, -toRemove.length);
      } else {
        const lastIndex = this.accumulatedText.lastIndexOf(lastItem);
        if (lastIndex !== -1) {
          this.accumulatedText = this.accumulatedText.substring(0, lastIndex);
          if (this.accumulatedText.endsWith(";")) {
            this.accumulatedText = this.accumulatedText.slice(0, -1);
          }
        } else {
          const parts = this.accumulatedText.split(";").filter(p => p.trim());
          if (parts.length > 0) {
            parts.pop();
            this.accumulatedText = parts.join(";");
            if (this.accumulatedText) this.accumulatedText += ";";
          }
        }
      }

      this.text = this.accumulatedText;
      this.canRevoke = this.confirmedHistory.length > 0;
      this.savePersistedHistory();
      await this.speakText(`已删除${lastItem}`);
      return true;
    },

    // ==================== 多任务历史记录恢复与持久化 ====================
    // 任务列表（id/name/userName）存后端 MySQL；运行时数据（text/accumulatedText 等）按 taskId 存 localStorage
    getHistoryPrefix() {
      const name = this.user && this.user.name ? this.user.name : "default";
      return "meeting_" + name + "_";
    },

    // 任务运行时数据的 localStorage 键（按 taskId 隔离，与登录用户无关——taskId 全局唯一）
    getTaskDataKey(taskId) {
      return "meeting_task_" + taskId + "_data";
    },

    // 同步当前运行时数据到 tasks 数组
    syncCurrentTaskToData() {
      if (!this.currentTaskId) return;
      const task = this.tasks.find(t => t.id === this.currentTaskId);
      if (!task) return;
      task.text = this.text;
      task.accumulatedText = this.accumulatedText;
      task.confirmedHistory = this.confirmedHistory ? [...this.confirmedHistory] : [];
      task.canRevoke = this.canRevoke;
      task.updatedAt = Date.now();
    },

    // 保存当前任务的运行时数据到 localStorage（按 taskId 隔离）；任务列表本身不存 localStorage，由后端管理
    saveTasks() {
      this.syncCurrentTaskToData();
      if (!this.currentTaskId) return;
      const task = this.tasks.find(t => t.id === this.currentTaskId);
      if (!task) return;
      try {
        localStorage.setItem(this.getTaskDataKey(this.currentTaskId), JSON.stringify({
          text: task.text || "",
          accumulatedText: task.accumulatedText || "",
          confirmedHistory: task.confirmedHistory || [],
          canRevoke: !!task.canRevoke
        }));
      } catch (e) {
        console.error("保存任务运行时数据失败:", e);
      }
    },

    // 从后端按登录用户名加载任务列表，并从 localStorage 填充每个任务的运行时数据
    async loadTasks() {
      if (!this.user || !this.user.name) {
        this.tasks = [];
        return;
      }
      try {
        const res = await this.$http.post("/task/list_page_name", {
          userName: this.user.name,
          currentPage: 1,
          pageSize: 1000
        });
        if (res.data.code === "200" && res.data.object) {
          const dataList = res.data.object.data || [];
          this.tasks = dataList.map(t => {
            // 从 localStorage 加载该任务的运行时数据
            let runtimeData = {text: "", accumulatedText: "", confirmedHistory: [], canRevoke: false};
            const dataStr = localStorage.getItem(this.getTaskDataKey(t.id));
            if (dataStr) {
              try {
                runtimeData = JSON.parse(dataStr);
              } catch (e) { /* keep default */
              }
            }
            return {
              id: t.id,
              name: t.taskName || t.name || "未命名任务",
              userName: t.userName,
              createdAt: t.createTime ? new Date(t.createTime).getTime() : Date.now(),
              updatedAt: t.modifyTime ? new Date(t.modifyTime).getTime() : Date.now(),
              text: runtimeData.text || "",
              accumulatedText: runtimeData.accumulatedText || "",
              confirmedHistory: runtimeData.confirmedHistory || [],
              canRevoke: !!runtimeData.canRevoke
            };
          });
        } else {
          this.tasks = [];
          if (res.data.code === '401') router.push("/login");
        }
      } catch (e) {
        console.error("从后端加载任务失败:", e);
        this.$message.error("加载任务列表失败，请检查网络");
        this.tasks = [];
      }
    },

    // 加载指定任务的数据到运行时
    loadTaskData(taskId) {
      const task = this.tasks.find(t => t.id === taskId);
      if (!task) return;
      this.text = task.text || "";
      this.accumulatedText = task.accumulatedText || "";
      this.confirmedHistory = task.confirmedHistory ? [...task.confirmedHistory] : [];
      this.canRevoke = !!task.canRevoke;
      this.resultText = "";
      this.resultTextTemp = "";
    },

    // 保存当前任务（调用处保持原名，语义不变）
    savePersistedHistory() {
      this.saveTasks();
    },

    // 清除当前任务的文本历史（上传成功后调用）
    clearPersistedHistory() {
      if (!this.currentTaskId) return;
      const task = this.tasks.find(t => t.id === this.currentTaskId);
      if (task) {
        task.text = "";
        task.accumulatedText = "";
        task.confirmedHistory = [];
        task.canRevoke = false;
        task.updatedAt = Date.now();
      }
      this.text = "";
      this.accumulatedText = "";
      this.confirmedHistory = [];
      this.canRevoke = false;
      this.saveTasks();
    },

    async loadTaskWAV(taskId) {
      accumulatedWAVBuffer = await loadAccumulatedWAV(taskId);
      if (accumulatedWAVBuffer) {
        console.log("已加载任务" + taskId + "历史WAV，将与新录音拼接，大小:", accumulatedWAVBuffer.byteLength, "字节");
      }
    },

    async saveTaskWAV(taskId) {
      if (!taskId || !accumulatedWAVBuffer) return;
      await saveAccumulatedWAV(taskId, accumulatedWAVBuffer);
    },

    async clearTaskWAV(taskId) {
      if (!taskId) return;
      await clearAccumulatedWAV(taskId);
      if (this.currentTaskId === taskId) {
        accumulatedWAVBuffer = null;
      }
    },

    // ==================== 上传功能（拼接全部WAV片段后上传）====================
    async uploadWAVData() {
      if (!this.accumulatedText || this.accumulatedText === "") {
        this.$message.warning("没有可上传的记录内容");
        return;
      }

      this.loading = true;

      try {
        // 先结束当前WAV录音片段，并拼接到历史WAV
        await this.finishCurrentWAVSegment();

        if (!accumulatedWAVBuffer) {
          this.$message.warning("没有录制到音频数据");
          this.loading = false;
          return;
        }

        const wavBlob = new Blob([accumulatedWAVBuffer], {type: 'audio/wav'});
        const currentTask = this.tasks.find(t => t.id === this.currentTaskId);
        const taskName = (currentTask && currentTask.name ? currentTask.name : '未命名任务').trim().replace(/\s+/g, '_');
        const fileName = `${taskName}_${Date.now()}.wav`;
        const fileOfBlob = new File([wavBlob], fileName);

        let formData = new FormData();
        formData.append('multipartFile', fileOfBlob);
        formData.append('userName', this.user.name);
        // 任务名（含 主任务号-子任务号 前缀），后端据此把 wav/txt 归档到 ftp/Record/<主任务号>/
        formData.append('taskName', currentTask && currentTask.name ? currentTask.name : '');
        // 后端不做改动：把材长编码进 originContent 末尾(形如 ;WOODLEN=2)随文本一起存储
        // 文件管理列表加载时从 originContent 末尾解析材长并剥离显示
        const uploadContent = this.accumulatedText.replaceAll(" ", ",") + `;WOODLEN=${this.woodLen}`;
        formData.append('originContent', uploadContent);

        console.log("上传的文本内容(含材长标记):", uploadContent);
        console.log("上传的音频文件:", fileOfBlob);

        const response = await fetch(`https://${WHITE_IP}/document/upload_train`, {
          method: 'POST',
          body: formData
        });
        const res = await response.json();
        console.log(res);

        if (res.code === "200") {
          this.$message.success("记录上传成功！");
          // 上传成功后保留当前文本用于统计展示
          this.statText = calcStat(this.accumulatedText, this.woodLen);
          // 上传成功：清空当前任务的历史WAV（内存+持久化）
          accumulatedWAVBuffer = null;
          await clearAccumulatedWAV(this.currentTaskId);
          this.clearPersistedHistory();

          // 上传完成后：根据用户名查询所有任务 ID，调用 /task/list_delete 批量删除该用户的全部任务
          try {
            const listRes = await this.$http.post("/task/list_page_name", {
              userName: this.user.name,
              currentPage: 1,
              pageSize: 1000
            });
            if (listRes.data.code === "200" && listRes.data.object) {
              const ids = (listRes.data.object.data || []).map(t => t.id);
              if (ids.length > 0) {
                await this.$http.post("/task/list_delete", {removeIdList: ids});
              }
            }
          } catch (e) {
            console.error("上传后清理任务失败:", e);
          }

          // 清理 localStorage 中所有任务的运行时数据
          this.tasks.forEach(t => {
            try {
              localStorage.removeItem(this.getTaskDataKey(t.id));
            } catch (e) { /* ignore */
            }
            clearAccumulatedWAV(t.id);
          });
          this.tasks = [];
          this.currentTaskId = null;
          this.text = "";
          this.accumulatedText = "";
          this.confirmedHistory = [];
          this.canRevoke = false;

          console.log("上传完成，该用户所有任务已清理");
        } else {
          this.$message.error("上传失败: " + res.message);
        }
      } catch (error) {
        console.error('Error:', error);
        this.$message.error("上传失败，请检查网络");
      } finally {
        this.loading = false;
      }
    },
  },
}
</script>

<style>
/* 材长输入 + 查看统计入口 */
.wood-len-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  background: #f5f7fa;
  border-radius: 4px;
  margin-top: 8px;
}

.wood-len-label {
  font-size: 14px;
  color: #303133;
  white-space: nowrap;
}

.wood-len-input {
  width: 130px;
}

.vad-eos-label {
  font-size: 13px;
  color: #303133;
  white-space: nowrap;
  margin-left: 4px;
}

.vad-eos-input {
  width: 110px;
}

/* 统计弹窗（自实现 modal，H5 兼容） */
.stat-modal-mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.stat-modal {
  background: #fff;
  border-radius: 8px;
  width: 100%;
  max-width: 520px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.18);
}

.stat-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #ebeef5;
}

.stat-modal-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.stat-modal-close {
  border: none;
  background: transparent;
  font-size: 24px;
  line-height: 1;
  color: #909399;
  cursor: pointer;
  padding: 0 6px;
  font-weight: 300;
}

.stat-modal-close:hover {
  color: #409eff;
}

.stat-modal-body {
  padding: 16px;
  overflow-y: auto;
  flex: 1;
}

.stat-modal-footer {
  padding: 10px 16px calc(10px + env(safe-area-inset-bottom)) 16px;
  border-top: 1px solid #ebeef5;
  text-align: right;
}

.stat-dialog-pre {
  margin: 0;
  padding: 12px;
  background: #f5f7fa;
  border-radius: 4px;
  font-family: Consolas, "Courier New", monospace;
  font-size: 13px;
  line-height: 1.7;
  color: #303133;
  white-space: pre-wrap;
  word-break: break-all;
}

.stat-empty {
  color: #909399;
  font-size: 14px;
}

.task-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  padding: 10px;
  background: #f5f7fa;
  border-radius: 4px;
}

.Meeting-textarea-wrap {
  height: 150px;
  display: flex;
  flex-direction: column;
}

.task-list {
  display: flex;
  gap: 8px;
  flex: 1;
  overflow-x: auto;
}

.task-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  background: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
  white-space: nowrap;
  font-size: 13px;
  transition: all 0.2s;
  flex-shrink: 0;
}

.task-item.active {
  border-color: #409eff;
  color: #409eff;
  background: #ecf5ff;
}

.task-item:hover {
  border-color: #409eff;
}

.task-name {
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.task-edit {
  cursor: pointer;
  color: #909399;
  font-size: 13px;
  margin-left: 4px;
  flex-shrink: 0;
}

.task-edit:hover {
  color: #409eff;
}

.task-close {
  cursor: pointer;
  color: #909399;
  font-size: 12px;
  padding: 2px;
}

.task-close:hover {
  color: #f56c6c;
}
</style>
